import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { InitOptions } from 'i18next'

import jaTranslations from '@/i18n/locales/ja.json'
import enTranslations from '@/i18n/locales/en.json'

export const i18nConfig: InitOptions = {
  resources: {
    ja: {
      translation: jaTranslations,
    },
    en: {
      translation: enTranslations,
    },
  },
  fallbackLng: ['en', 'ja'],
  detection: {
    order: ['localStorage', 'navigator'],
    caches: ['localStorage'],
  },
  interpolation: {
    escapeValue: false,
    format: function (value, format) {
      if (format === 'number') return value.toString()
      return value
    },
  },
  debug: process.env.NODE_ENV === 'development',
  supportedLngs: ['ja', 'en'],
  nonExplicitSupportedLngs: false,
  load: 'languageOnly',
  // Improved handling of missing keys
  saveMissing: process.env.NODE_ENV === 'development',
  missingKeyHandler: (lng, ns, key) => {
    console.warn(`[i18n] Missing translation key: ${key} in namespace: ${ns} for language: ${lng}`)
  },
  // Cache configuration to prevent stale translations
  cache: {
    enabled: process.env.NODE_ENV === 'production',
    expirationTime: 24 * 60 * 60 * 1000, // 24 hours
  },
}

// Initialize i18n with React bindings synchronously to avoid "NO_I18NEXT_INSTANCE" errors
i18n.use(LanguageDetector).use(initReactI18next).init(i18nConfig)

// This function can be used to ensure i18n is fully initialized
// or to reinitialize it if needed
export const initI18n = async () => {
  if (i18n.isInitialized) return i18n
  try {
    await i18n.init(i18nConfig)
    return i18n
  } catch (error) {
    console.error('Failed to initialize i18n:', error)
    throw error
  }
}

export default i18n
